import React from "react";
import styled from "styled-components";
import MediaQuery from "../MediaQuery";

// background-color: #f3f2f5;
const Wrapper = styled.div`
  padding: 30px 0;
  padding-top: 100px;
  min-height: 100vh;
`;

const Stepper = styled.div`
  margin-bottom: 15px;
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  ${MediaQuery.tablet`
    font-size: 16px;
  `};
`;

const GreyBackgroundPage = ({ children, stepperText }) => (
  <Wrapper>
    <Stepper>{stepperText}</Stepper>
    <div class="container">{children}</div>
  </Wrapper>
);

export default GreyBackgroundPage;



// WEBPACK FOOTER //
// ./src/components/GreyBackgroundPage/index.js